import React, { PureComponent } from 'react';

import { getRequest } from 'api/ApiService';
import Teams from '../../../../api/Teams';
import Auth from '../../../../routes/Auth';

import { isSurveyFinished } from '../../../../api/Surveys';

import {
  Wrapper,
  PreTitle,
  Title,
  Text,
  ContentContainer,
  Charts
} from '../../components/ui';

import SurveyChart from '../../components/survey-chart';

class PeerRatingScoreSecond extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      reports: {},
    };
  }

  componentDidMount() {
    const { surveys } = this.props;

    const userId = Auth.getUserId();

    surveys.forEach(survey => {
      if (isSurveyFinished(survey)) {
        this.loadReport(survey, userId);
      }
    });
  }

  loadReport = async ({ id: survey_id, stage }, receiver_id) => {
    if (survey_id && Number(survey_id) > 0) {
      try {
        const { body: report } = await getRequest(
          `${process.env.REACT_APP_API_URL}v2/forms/score/${receiver_id}/${survey_id}/`
        );
        const { reports } = this.state;

        this.setState({
          reports: {
            ...reports,
            [stage]: report
          }
        });
      } catch (e) {
        // do nothing
      }
    }
  };

  render() {

    const { surveys } = this.props;
    const { reports } = this.state;

    return (
      <Wrapper>
        <PreTitle>Overview</PreTitle>
        <Title>Peer Rating Score Trend</Title>
        <Text>
          <p>Here’s the change in your peer rating score.</p>
        </Text>
        <ContentContainer>
          <Charts.Wrapper
            setMaxHeight={Object.keys(reports).length === 1 ? true : false}
          >
            <Charts.Teams.Wrapper>
              <Charts.Teams.Row>
                <Charts.Teams.TeamColor
                  background={Teams.currentTeamColor()}
                />
                <Charts.Teams.TeamName>You</Charts.Teams.TeamName>
              </Charts.Teams.Row>
              <Charts.Teams.Row margin="0 20px">
                <Charts.Teams.TeamColor background="#eee" />
                <Charts.Teams.TeamName>Team Average</Charts.Teams.TeamName>
              </Charts.Teams.Row>
              <Charts.Teams.Row margin="0 20px">
                <Charts.Teams.TeamColor background="#c4c4c4" />
                <Charts.Teams.TeamName>Team Median</Charts.Teams.TeamName>
              </Charts.Teams.Row>
            </Charts.Teams.Wrapper>
            <Charts.Chart>
              <SurveyChart
                reports={reports}
                surveys={surveys}
                isSurveyFinished={isSurveyFinished}
              />
            </Charts.Chart>
          </Charts.Wrapper>
        </ContentContainer>
      </Wrapper >
    );
  }

}

export default PeerRatingScoreSecond;



// WEBPACK FOOTER //
// ./src/components/peer-feedback/pages/overview/peer-rating-score-second.js